import React from 'react'
let validate = 0;
const ValidateContext = React.createContext(validate);
export default ValidateContext;